export default __webpack_public_path__ + "static/media/signup-mock.350e50ab.svg";